/* eslint no-bitwise: 0 */ // Allow bitwise in this file.

import _ from 'lodash';
import tinycolor from 'tinycolor2';

// QReserve useful colors as strings.
const White = '#ffffff';
const QBlueColor = '#1e394c';
const QLightBlueColor = '#2879b2';
const QPinkColor = '#ed2a7a';
const QOffGreyColor = '#f9fbff';
const ElectricBlue = '#5be9ff';
export const BrickRed = '#841f27';
export const SuccessColor = '#258832';
export const WarningColor = '#CC4B00';
export const DangerColor = '#D43900';

// Functional color variables
export const PrimaryColor = QBlueColor;
export const SecondaryColor = QLightBlueColor;
export const AccentColor = QPinkColor;
export const BackgroundColor = QOffGreyColor;
export const DefaultLabelTextColor = White;
export const ActiveLinkColor = ElectricBlue;
export const TextColor = QBlueColor;

// DefaultColorStyle is the default ColorStyle for anything being colored by
// portal colors but lacking a portal.
export const DefaultColorStyle = {
  color: PrimaryColor,
};

export const colorStyle = (theme) => {
  let color = PrimaryColor;
  if (theme) color = theme.primaryColor;
  return {
    color,
  };
};

export const labelStyle = (theme) => {
  const color = White;
  let backgroundColor = PrimaryColor;
  let borderColor = PrimaryColor;
  if (theme) {
    backgroundColor = theme.primaryColor;
    borderColor = theme.primaryColor;
  }
  return {
    color,
    'background-color': backgroundColor,
    'border-color': borderColor,
  };
};

// DefaultLabelStyle is the default LabelStyle for anything being colored by
// portal colors but lacking a portal.
export const DefaultLabelStyle = {
  color: DefaultLabelTextColor,
  'background-color': PrimaryColor,
  'border-color': PrimaryColor,
};

// ConvertRGBToHex normalizes all input colors to a 7 string hex line
// prefixed with a hash.
export const ConvertRGBToHex = (colorStr) => {
  if (colorStr.length === 7 && colorStr[0] === '#') {
    return colorStr;
  }

  if (colorStr.length === 7 && colorStr[0] === '#') {
    return colorStr;
  }

  if (colorStr.length === 4 && colorStr[0] === '#') {
    const h1 = `${colorStr[1]}${colorStr[1]}`;
    const h2 = `${colorStr[2]}${colorStr[2]}`;
    const h3 = `${colorStr[3]}${colorStr[3]}`;
    return `#${h1}${h2}${h3}`;
  }

  const isRgb = colorStr.includes('rgb') || colorStr.includes('RGB');
  if (!isRgb) {
    throw Error(`unknown color type (${colorStr}) passed`);
  }

  let a = colorStr.split('(')[1].split(')')[0];
  a = a.split(',');
  const b = a.map((x) => {
    const xCopy = parseInt(x, 10).toString(16);
    return (xCopy.length === 1) ? `0${xCopy}` : xCopy;
  });

  return `#${b.join('')}`;
};

// TweakColorBrightness takes a 7-letter hexadecimal color col and tweaks it
// by the integer amount amt, yielding a lighter or darker color. Valid ranges
// are -239 ... 239 for amt. Underflowing or overflowing amt will result in
// black or white.
export const TweakColorBrightness = (col, amt) => {
  let colCopy = col;
  if (!col) colCopy = '#000000';
  let usePound = false;
  if (colCopy[0] === '#') {
    colCopy = colCopy.slice(1);
    usePound = true;
  }
  const num = parseInt(colCopy, 16);
  let r = (num >> 16) + amt;
  if (r > 255) r = 255;
  else if (r < 0) r = 0;
  let b = ((num >> 8) & 0x00FF) + amt;
  if (b > 255) b = 255;
  else if (b < 0) b = 0;
  let g = (num & 0x0000FF) + amt;
  if (g > 255) g = 255;
  else if (g < 0) g = 0;
  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
};

// will lighten a colour until it is almost white, but will not return
// actual white untill white is inputted.
export const LightenButNotWhite = (col) => {
  let lighterCol = col;
  const amounts = _.range(0, 100, 2.5);

  _.forEach(amounts, (amt) => {
    const newCol = tinycolor(col).lighten(amt).toHexString();
    if (newCol === '#ffffff') return false;
    lighterCol = newCol;
    return true;
  });

  return lighterCol;
};
